import { formatDistance } from '../../utils/units';

export default function VehicleCard({
  vehicle,
  analysis,
  selectable,
  selected,
  onToggleSelect,
  onClick,
}) {
  const label = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;
  const score = analysis?.healthScore;
  const scoreColor =
    score >= 80 ? 'var(--success)' : score >= 60 ? 'var(--warning)' : 'var(--danger)';
  const circumference = 2 * Math.PI * 12;
  const offset = score != null ? circumference - (score / 100) * circumference : circumference;

  return (
    <button
      onClick={selectable ? onToggleSelect : onClick}
      className="card"
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '14px 16px',
        cursor: 'pointer',
        textAlign: 'left',
        marginBottom: 10,
        borderColor: selected ? 'var(--accent)' : undefined,
      }}
    >
      {/* Checkbox in edit mode */}
      {selectable && (
        <div
          style={{
            width: 22,
            height: 22,
            borderRadius: 4,
            border: `2px solid ${selected ? 'var(--accent)' : 'var(--border)'}`,
            background: selected ? 'var(--accent)' : 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            transition: 'all 0.15s',
          }}
        >
          {selected && (
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </div>
      )}

      {/* Vehicle thumbnail or icon placeholder */}
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 'var(--radius-sm)',
          background: vehicle.photo ? `url(${vehicle.photo}) center/cover no-repeat` : 'var(--bg-elevated)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          overflow: 'hidden',
        }}
      >
        {!vehicle.photo && (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 17h14M5 17a2 2 0 01-2-2V9a1 1 0 011-1h1l2-4h10l2 4h1a1 1 0 011 1v6a2 2 0 01-2 2M5 17a2 2 0 002 2h10a2 2 0 002-2" />
            <circle cx="7.5" cy="17" r="1.5" />
            <circle cx="16.5" cy="17" r="1.5" />
          </svg>
        )}
      </div>

      {/* Vehicle info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: '0.9375rem', lineHeight: 1.3 }}>{label}</div>
        <div style={{ fontSize: '0.75rem', color: vehicle.tmu ? 'var(--warning)' : 'var(--text-muted)', marginTop: 2 }}>
          {vehicle.mileage
            ? `${formatDistance(vehicle.mileage, vehicle.distance_units)}${vehicle.tmu ? ' (TMU)' : ''}`
            : 'Mileage not set'}
          {vehicle.condition && (
            <span style={{ marginLeft: 8, color: 'var(--text-secondary)' }}>
              {vehicle.condition}
            </span>
          )}
        </div>
        {vehicle.collaborators && vehicle.collaborators.length > 0 && (
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 3,
              marginTop: 3,
              padding: '1px 6px',
              borderRadius: 100,
              background: 'rgba(59, 130, 246, 0.12)',
              color: '#3b82f6',
              fontSize: '0.625rem',
              fontWeight: 600,
            }}
          >
            Shared
          </span>
        )}
      </div>

      {/* Mini health ring or chevron */}
      {score != null ? (
        <div style={{ position: 'relative', flexShrink: 0, width: 32, height: 32 }}>
          <svg width="32" height="32" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="12" fill="none" stroke="var(--bg-elevated)" strokeWidth="3" />
            <circle
              cx="16"
              cy="16"
              r="12"
              fill="none"
              stroke={scoreColor}
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              transform="rotate(-90 16 16)"
            />
          </svg>
          <span
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.5625rem',
              fontWeight: 700,
              color: scoreColor,
            }}
          >
            {score}
          </span>
        </div>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      )}
    </button>
  );
}
